module.exports = __webpack_public_path__ + "static/media/THERAPIES_Active.7a87e6cb.png";